import React, { useEffect, useState } from 'react';
import {Table} from 'reactstrap'
import { getFoodList } from './_food_srv';
import { AppAlert } from '../../utils/index';


function Foods(props) {
    const [foodList, setFoodList] = useState([])
    useEffect(() => {
        getFoodList().then(res => {
            if (res.status === 200) {
                if (res.data)
                    if (res.data.length > 0) {
                        setFoodList(res.data)
                    }
            }
        }).catch(err => {
            if (err.response)
                AppAlert(err.response.status, err.response.data)
        })
    }, [])

    function renderTableRow(e, index) {
        return (
            <tr key={index}>
                <th scope="row">{e.Id}</th>
                {/* <td>{e.Id}</td> */}
                <td>{e.Title}</td>
            </tr>
        )
    }
    return (
        <div>
            <Table className="whiteBox">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>نام غذا</th>
                        {/* <th>عملیات</th> */}
                    </tr>
                </thead>
                <tbody>
                    {
                        foodList.length >0 ?
                        foodList.map((item, index) => {
                            return renderTableRow(item, index);
                        }) : null
                    }
                </tbody>
            </Table>
        </div>
    )
}

export default Foods;